import React from 'react';
import { Pagination } from 'react-bootstrap';

interface CustomPaginationProps {
  numberOfPages: number;
  currentPage: number;
  onPageChange: (_page: number) => void;
}

const CustomPagination = ({ numberOfPages, currentPage, onPageChange }: CustomPaginationProps) => {
  const renderPages = () => {
    const items = [];

    items.push(
      <Pagination.Item
        key={1}
        active={currentPage === 1}
        onClick={() => {
          onPageChange(1);
        }}
      >
        1
      </Pagination.Item>
    );

    if (currentPage > 4) {
      items.push(<Pagination.Ellipsis key="left-ellipsis" disabled />);
    }

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(numberOfPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => {
            onPageChange(i);
          }}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < numberOfPages - 3) {
      items.push(<Pagination.Ellipsis key="right-ellipsis" disabled />);
    }

    if (numberOfPages > 1) {
      items.push(
        <Pagination.Item
          key={numberOfPages}
          active={currentPage === numberOfPages}
          onClick={() => {
            onPageChange(numberOfPages);
          }}
        >
          {numberOfPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return <Pagination>{renderPages()}</Pagination>;
};

export default CustomPagination;
